import { ScreenProps } from "../../App";
import { useKicktippQuery } from "./queries/useKicktippQuery";
import { shortName, teamLogo } from "./teams";
import "./styles/Kicktipp.sass";

const KicktippGameDayScreen: React.FC<ScreenProps> = ({
  duration,
  christmasTime,
  isActive,
}) => {
  const data = useKicktippQuery();

  if (data.isLoading) return <div>Loading...</div>;

  if (data.isError || !data.data) return <div>Error...</div>;

  const { games } = data.data;

  return (
    <div className="kicktippScreen gameDayScreen">
      <div className="h1">
        <h1><span>9e</span> Buli-Tipp</h1>
      </div>
      <div className="h2"><h2>Spieltag</h2></div>
      <div className={`gamesGrid ${games.length > 5 ? "twoColumns" : ""}`}>
        {games.map((game, index) => (
          <div className="gameCard" key={index}>
            <div className="gameMeta">
              <span className="kickoff">{game.kickoff}</span>
              {game.group && <span className="group">{game.group}</span>}
            </div>
            <div className="gameTeams">
              <span className="team home">
                <span className="teamName">{shortName(game.home)}</span>
                {teamLogo(game.home) && (
                  <img className="crest" src={teamLogo(game.home)} alt="" />
                )}
              </span>
              <span className="result">{game.result || "-:-"}</span>
              <span className="team away">
                {teamLogo(game.away) && (
                  <img className="crest" src={teamLogo(game.away)} alt="" />
                )}
                <span className="teamName">{shortName(game.away)}</span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KicktippGameDayScreen;
